module.exports = __webpack_public_path__ + "images/98afb09c2eb2f4260bf45e75358b5e70-yale_lock_illustration_green.png";